// eslint-disable-next-line no-restricted-imports
import { useSearchParams as useSearchParamsBase } from 'react-router-dom';

// необходимо, чтобы при любом переходе сохранялся параметр customization, т.к. с его помощью определяется
// внешний вид некоторых страниц для банков партнеров и для пользователя нежелательно при каком-либо переходе
// в агенте внезапно получить дефолтное отображение сайта
export const useSearchParams = () => {
  const [searchParamsBase, setSearchParamsBase] = useSearchParamsBase();
  const customization = searchParamsBase.get('customization');

  const setSearchParams = (params: { [x: string]: string }) => {
    const search = customization ? { ...params, customization } : params;
    setSearchParamsBase(search);
  };

  const result: [typeof searchParamsBase, typeof setSearchParams] = [
    searchParamsBase,
    setSearchParams,
  ];
  return result;
};

export const convertURLSearchParamsToObject = (params: URLSearchParams) => {
  const result: { [x: string]: string } = {};

  params.forEach((value, key) => {
    result[key] = value;
  });

  return result;
};
